import { render, staticRenderFns } from "./FirstCompany.vue?vue&type=template&id=56311956&scoped=true"
import script from "./FirstCompany.vue?vue&type=script&lang=js"
export * from "./FirstCompany.vue?vue&type=script&lang=js"
import style0 from "./FirstCompany.vue?vue&type=style&index=0&id=56311956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56311956",
  null
  
)

export default component.exports